import { render, staticRenderFns } from "./MpDashboardBanner.vue?vue&type=template&id=2f69c0db&scoped=true&"
import script from "./MpDashboardBanner.vue?vue&type=script&lang=ts&"
export * from "./MpDashboardBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MpDashboardBanner.vue?vue&type=style&index=0&id=2f69c0db&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69c0db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VContainer,VRow})
